<template>
  <div class="main">
    <c-panel title="Alunos no Transporte" titleIcon="fas fa-user-friends">
      <list></list>
    </c-panel>
  </div>
</template>

<script>
import list from "./list"

export default {
  components: { list }
}
</script>

